const PHONE_MAX_LENGTH = 11;
const AREA_CODE_LENGTH = 2;
const LANDLINE_LENGTH = 10;

/** Fica só com os dígitos do telefone (DDD + número, no máximo 11). */
export function unmaskPhone(value: string): string {
  return value.replace(/\D/g, '').slice(0, PHONE_MAX_LENGTH);
}

/**
 * Aplica a máscara progressivamente: `(00) 0000-0000` (fixo) ou `(00) 00000-0000` (celular,
 * com 11 dígitos).
 */
export function maskPhone(value: string): string {
  const digits = unmaskPhone(value);
  if (digits.length === 0) return '';
  const areaCode = digits.slice(0, AREA_CODE_LENGTH);
  const number = digits.slice(AREA_CODE_LENGTH);
  if (number.length === 0) return `(${areaCode}`;
  const prefixLength = digits.length > LANDLINE_LENGTH ? 5 : 4;
  const prefix = number.slice(0, prefixLength);
  const suffix = number.slice(prefixLength);
  return `(${areaCode}) ${prefix}${suffix.length > 0 ? `-${suffix}` : ''}`;
}
